export const REPORT_TYPE_OPTIONS = [
  { value: 'TOTAL_STOCK',   label: 'Total Stock' },
  { value: 'EXPIRED_STOCK', label: 'Expired Stock' },
  { value: 'LOW_STOCK',     label: 'Low Stock' },
  { value: 'STOCK_SUMMARY', label: 'Stock Summary' },
];

// Report types that don't require a date range filter
export const NO_DATE_RANGE_TYPES = new Set(['LOW_STOCK', 'STOCK_SUMMARY']);

export const SCOPE_LEVEL_OPTIONS = [
  { value: 'STATE',    label: 'State' },
  { value: 'DISTRICT', label: 'District' },
  { value: 'TALUKA',   label: 'Taluka' },
  { value: 'CENTER',   label: 'Vaccination Center' },
];

// Used only by DownloadFormatModal — NOT included in the Generate report modal.
export const FILE_FORMAT_OPTIONS = [
  { value: 'CSV',   label: 'CSV' },
  { value: 'EXCEL', label: 'Excel' },
  { value: 'PDF',   label: 'PDF' },
];

export const STATUS_OPTIONS = [
  { value: 'PENDING',     label: 'Pending' },
  { value: 'IN_PROGRESS', label: 'In Progress' },
  { value: 'GENERATED',   label: 'Generated' },
  { value: 'FAILED',      label: 'Failed' },
];

export const MAX_DAYS_BY_SCOPE = {
  STATE:    { CSV: 60,  EXCEL: 60,  PDF: 30  },
  DISTRICT: { CSV: 180, EXCEL: 180, PDF: 90  },
  TALUKA:   { CSV: 365, EXCEL: 365, PDF: 180 },
  CENTER:   { CSV: 365, EXCEL: 365, PDF: 365 },
};

export const STATES = [
  { value: 'gujarat', label: 'Gujarat' },
];
